import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SITE } from '../data/content';
import './Contact.css';

export default function Contact() {
  const { t } = useLanguage();
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`${t.contact.formTitle} — ${form.name}`);
    const body = encodeURIComponent(`${form.message}\n\n${t.contact.formEmail}: ${form.email}`);
    window.location.href = `mailto:${SITE.email}?subject=${subject}&body=${body}`;
  };

  return (
    <section id="contact" className="section section--dark contact">
      <div className="container contact__inner">
        <div className="contact__info">
          <span className="kicker">{t.contact.kicker}</span>
          <h2 className="section-title">{t.contact.title}</h2>
          <p className="contact__desc">{t.contact.desc}</p>

          <div className="contact__details">
            <div className="contact__email-block">
              <span className="contact__label">{t.contact.emailLabel}</span>
              <a href={`mailto:${SITE.email}`} dir="ltr" className="contact__email">
                {SITE.email}
              </a>
            </div>
            <div className="contact__email-block">
              <span className="contact__label">{t.contact.phoneLabel}</span>
              <a href={`tel:${SITE.phoneHref}`} dir="ltr" className="contact__email">
                {SITE.phone}
              </a>
            </div>
          </div>
        </div>

        <div className="contact__panel">
          <form className="contact__form" onSubmit={handleSubmit}>
            <h3>{t.contact.formTitle}</h3>
            <label>
              {t.contact.formName}
              <input type="text" name="name" required value={form.name} onChange={handleChange} />
            </label>
            <label>
              {t.contact.formEmail}
              <input type="email" name="email" required value={form.email} onChange={handleChange} />
            </label>
            <label>
              {t.contact.formMessage}
              <textarea name="message" rows="4" required value={form.message} onChange={handleChange} />
            </label>
            <button type="submit" className="btn btn--primary">
              {t.contact.formSubmit}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
